"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleSecondaryButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BaseButton = require("./BaseButton");
var _utils = require("./utils");
var _Icon = require("../Icon");
var _excluded = ["size", "icon", "filled", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var buttonStyles = function buttonStyles(size, filled) {
  return (0, _classnames.default)('btn-circle', 'btn-circle-secondary', {
    'btn-circle-small': size === 'small'
  }, {
    'btn-circle-large': size === 'large'
  }, {
    'btn-circle-secondary-filled': filled
  });
};
var CircleSecondaryButton = function CircleSecondaryButton(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    icon = _ref.icon,
    filled = _ref.filled,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = buttonStyles(size, filled);
  return /*#__PURE__*/_react.default.createElement(_BaseButton.BaseButton, _extends({
    className: (0, _classnames.default)(styles, className)
  }, props), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: icon,
    className: (0, _utils.iconStyles)(size)
  }));
};
exports.CircleSecondaryButton = CircleSecondaryButton;